import { Outlet, Link } from "react-router-dom";
import ApperIcon from "@/components/ApperIcon";

const PublicLayout = () => {
  return (
    <div className="min-h-screen bg-background-primary">
      {/* Public Header */}
      <header className="sticky top-0 z-sticky bg-background-secondary border-b border-primary/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
<Link to="/pubblico" className="flex items-center gap-3">
              <img
                src="/ps-logo.svg"
                alt="PubblicitaSoverato Logo"
                className="w-10 h-10 shrink-0 object-contain"
                style={{ minWidth: '40px', maxHeight: '48px' }}
              />
              <span className="text-sm font-display font-bold text-white tracking-tight" title="PUBBLICITASOVERATO">PUBBLICITASOVERATO</span>
            </Link>

            {/* Admin Link */}
            <Link
              to="/"
              className="flex items-center gap-2 px-4 py-2 rounded-button text-gray-300 hover:text-white hover:bg-primary/10 transition-colors duration-normal"
            >
              <ApperIcon name="Settings" className="w-4 h-4" />
              <span className="hidden sm:inline">Area Admin</span>
            </Link>
          </div>
        </div>
      </header>

      {/* Page Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
};

export default PublicLayout;